/* NOPA — country-conditional checkout fields.
   Hard-blocks "Checkout" in both the cart drawer and the /cart page for
   Qatar/UAE (Zone/Street/Building) and South Korea (PCCC) until filled in.
   No effect for any other country. Value is persisted as a cart attribute
   via the native Cart AJAX API, so it survives drawer re-renders and shows
   up on the order in Shopify admin. */
(function () {
  if (window.__nopaConditionalFieldsBound) return;
  window.__nopaConditionalFieldsBound = true;

  var FIELD_MAP = {
    QA: { key: 'zone', attrKey: 'NOPA - Zone / Street / Building No.' },
    AE: { key: 'zone', attrKey: 'NOPA - Zone / Street / Building No.' },
    KR: { key: 'pccc', attrKey: 'NOPA - Customs Clearance Code (PCCC)' }
  };
  var BUTTON_CONTEXT = { 'CartDrawer-Checkout': 'drawer', checkout: 'page' };

  function getCountry() {
    var el = document.querySelector('[data-nopa-country]');
    return el ? el.getAttribute('data-nopa-country') : null;
  }

  function fieldIds(key, context) {
    return {
      wrap: 'nopa-field-' + key + '-' + context,
      input: 'nopa-input-' + key + '-' + context
    };
  }

  function showError(ids) {
    var wrap = document.getElementById(ids.wrap);
    if (!wrap) return;
    wrap.classList.add('nopa-cfield--error');
    wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var input = document.getElementById(ids.input);
    if (input) input.focus();
  }

  function clearError(ids) {
    var wrap = document.getElementById(ids.wrap);
    if (wrap) wrap.classList.remove('nopa-cfield--error');
  }

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function saveAttribute(attrKey, value) {
    var attributes = {};
    attributes[attrKey] = value;
    return fetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).catch(function () {});
  }

  var saveTimer = null;

  document.addEventListener('input', function (e) {
    var input = e.target.closest ? e.target.closest('[data-nopa-input]') : null;
    if (!input) return;
    var key = input.getAttribute('data-nopa-input');
    var context = input.id.slice(('nopa-input-' + key + '-').length);
    clearError(fieldIds(key, context));
    var attrKey = key === 'zone' ? FIELD_MAP.QA.attrKey : FIELD_MAP.KR.attrKey;
    clearTimeout(saveTimer);
    var value = input.value.trim();
    saveTimer = setTimeout(function () {
      saveAttribute(attrKey, value);
    }, 600);
  });

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest ? e.target.closest('#CartDrawer-Checkout, #checkout') : null;
      if (!btn) return;

      if (btn.dataset.nopaBypass === '1') {
        btn.dataset.nopaBypass = '';
        return;
      }

      var country = getCountry();
      var cfg = country ? FIELD_MAP[country] : null;
      if (!cfg) return;

      var context = BUTTON_CONTEXT[btn.id];
      var ids = fieldIds(cfg.key, context);
      var input = document.getElementById(ids.input);
      var value = input ? input.value.trim() : '';

      if (!value) {
        e.preventDefault();
        e.stopPropagation();
        showError(ids);
        return;
      }

      clearError(ids);
      e.preventDefault();
      e.stopPropagation();
      saveAttribute(cfg.attrKey, value).then(function () {
        btn.dataset.nopaBypass = '1';
        btn.click();
      });
    },
    true
  );
})();
